import { combineReducers } from "redux";

import aisVesselsReducer from "../slices/aisVessels";
import billingCodeListReducer from "../slices/accounting";
import crewReducer from "../slices/crew";
import activitieReducer from "../slices/activities";
import agencyFeeReducer from "../slices/agencyFee";
import berthOutagesReducer from "../slices/berthOutages";
import bunkerReducer from "../slices/bunkerFreshWater";
import bunkerDetailReducer from "../slices/bunkerFreshWaterDetail";
import callListReducer from "../slices/callList";
import callsBlacklistListReducer from "../slices/callsBlackList"
import cargoReducer from "../slices/cargo";
import channelClosureReducer from "../slices/channelClosure";
import clientUpdateReducer from "../slices/clientDetailUpdate";
import clientDetailsReducer from "../slices/clientFormUpdate";
import historyListReducer from "../slices/clientHistory";
import closureReportSlicesReducer from "../slices/closuresReport";
import companyReducer from "../slices/company";
import companyListReducer from "../slices/companyList";
import deliveryReducer from "../slices/delivery";
import directBillingReducer from "../slices/directBilling"
import dockageFeeReducer from "../slices/dockageFee"
import dockRestrictionReducer from "../slices/dockRestriction";
import documentListReducer from "../slices/documents";
import emailReducer from "../slices/email";
import emailHistoryReducer from "../slices/emailHistory";
import gateAccessReducer from "../slices/gateAccess";
import gatesReducer from "../slices/gates";
import gradesReducer from "../slices/grades";
import locationGradesReducer from "../slices/locationGrades";
import historyReducer from "../slices/history";
import incomingCallsReducer from "../slices/incomingCalls";
import knowledgeBaseReducer from "../slices/knowledgeBase";
import locationReducer from "../slices/location";
import menuReducer from "../slices/menu";
import notificationListReducer from "../slices/notificationList";
import onBoardReducer from "../slices/onBoard";
import pdaCalculatorSliceReducer from "../slices/pdaCalculator";
import peopleListReducer from "../slices/peopleList";
import PetsReducer from "../slices/pets";
import PetsJobsReducer from "../slices/petsJobs";
import phoneDirectoryReducer from "../slices/phoneDirectory";
import phoneListReducer from "../slices/phoneList";
import pickListReducer from "../slices/pickList";
import pilotChargeReducer from "../slices/pilotCharge";
import pilotTrackerReducer from "../slices/pilotTracker";
import portCallNOtificationReducer from "../slices/portCallNotification";
import portCallReducer from "../slices/portCalls";
import shiftingReducer from "../slices/shifting";
import sofReducer from "../slices/sof";
import sofDocumentListReducer from "../slices/sofDocuments";
import tagsReducer from "../slices/tags";
import terminalUpdatesReducer from "../slices/terminalUpdates";
import husbandryTasksReducer from "../slices/husbandryTasks";
import tasksReducer from "../slices/tasks";
import timelineReducer from "../slices/timeline";
import vesselListReducer from "../slices/vesselList";
import voyagesReducer from "../slices/voyages";
import voyageScheduleReducer from "../slices/voyageSchedule";
import warningsReducer from "../slices/warnings";

const rootReducer = combineReducers({
  aisVessels: aisVesselsReducer,
  menu: menuReducer,
  voyages: voyagesReducer,
  activities: activitieReducer,
  voyageSchedule: voyageScheduleReducer,
  knowledgeBase: knowledgeBaseReducer,
  cargo: cargoReducer,
  pickList: pickListReducer,
  companyList: companyListReducer,
  history: historyReducer,
  onBoard: onBoardReducer,
  delivery: deliveryReducer,
  bunker: bunkerReducer,
  bunkerDetail: bunkerDetailReducer,
  vesselList: vesselListReducer,
  notificationList: notificationListReducer,
  phoneList: phoneListReducer,
  billingCodeList: billingCodeListReducer,
  clientDetails: clientDetailsReducer,
  historyList: historyListReducer,
  clientUpdate: clientUpdateReducer,
  company: companyReducer,
  peopleList: peopleListReducer,
  petsJobs: PetsJobsReducer,
  pets: PetsReducer,
  location: locationReducer,
  portCalls: portCallReducer,
  shifting: shiftingReducer,
  channelClosure: channelClosureReducer,
  pilotCharge: pilotChargeReducer,
  portCallNOtification: portCallNOtificationReducer,
  calls: callListReducer,
  agencyFee: agencyFeeReducer,
  dockRestriction: dockRestrictionReducer,
  closureReports: closureReportSlicesReducer,
  pdaCalcultor: pdaCalculatorSliceReducer,
  emailList: emailHistoryReducer,
  documents: documentListReducer,
  sofDocument: sofDocumentListReducer,
  sofStatement: sofReducer,
  dockageFeeList: dockageFeeReducer,
  directBilling: directBillingReducer,
  emails: emailReducer,
  callBlackList: callsBlacklistListReducer,
  gates: gatesReducer,
  gateAccess: gateAccessReducer,
  grades: gradesReducer,
  locationGrades: locationGradesReducer,
  tags: tagsReducer,
  tasks: tasksReducer,
  husbandryTasks: husbandryTasksReducer,
  phoneDirectory: phoneDirectoryReducer,
  incomingCalls: incomingCallsReducer,
  timeline: timelineReducer,
  warnings: warningsReducer,
  crew: crewReducer,
  terminalUpdates: terminalUpdatesReducer,
  berthOutages: berthOutagesReducer,
  pilotTracker: pilotTrackerReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
